export default "__VITE_ASSET__BZzxgGsD__"